export { default } from './ModalReplaceOOSProduct';
